import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { AppProvider } from './context/AppContext';  // Import your context provider
import { AuthProvider } from 'auth/authProvider';
import { ChakraProvider } from '@chakra-ui/react';
import AdminLayout from "layouts/Admin.js";
import LandingPage from "views/Dashboard/components/LandingPage.js";

ReactDOM.render(
  <ChakraProvider>
    <HashRouter>
      <AppProvider>
        <AuthProvider>
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route path="/admin" component={AdminLayout} />
            <Redirect to="/" />
          </Switch>
        </AuthProvider>
      </AppProvider>
    </HashRouter>
  </ChakraProvider>,
  document.getElementById('root')
);

